export interface SignalPair {
    type: string;
    listener: EventListenerOrEventListenerObject;
}

export function addSignal(target: any, event: string, listener: EventListenerOrEventListenerObject): void {
    // tslint:disable-next-line:ban
    addEventListener(event, listener);
    if (!target.signals) {
        target.signals = [];
    }
    target.signals.push({
        type: event,
        listener: listener
    });
}

export function removeAllSignals(target: any): void {
    if (target.signals) {
        target.signals.forEach((signalPair: SignalPair): void => {
            removeEventListener(signalPair.type, signalPair.listener);
        });
    }
}